import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: false,
  name: 'ingsvPriceFormat'
})
export class PriceFormatPipe implements PipeTransform {
  transform(value: any) {
    let result = '0';

    if (!isNaN(parseFloat(value)) && isFinite(value)) {
      result = Number(value).toFixed().toString().split(/(?=(?:...)*$)/)
        .join(' ');
    } else {
      return value;
    }

    return result;
  }
}
